import { Component, computed } from "@angular/core";
import { DashboardItemComponent } from "../dashboard-item/dashboard-item.component";
import { TranslatePipe } from "@ngx-translate/core";
import { NgIcon, provideIcons } from "@ng-icons/core";
import {
  lucideBook,
  lucideCheck,
  lucideInfo,
  lucidePointer,
  lucideTrophy,
} from "@ng-icons/lucide";
import { AppState } from "src/app/ngrx/reducers";
import { Store } from "@ngrx/store";
import { InstructionSelectors } from "src/app/ngrx/selectors";
import { InstructionActions } from "src/app/ngrx/actions";
import { PercentPipe } from "@angular/common";
import { Router } from "@angular/router";
import { InstructionItemComponent } from "../../instruction/instruction-item/instruction-item.component";
import { Instruction } from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styles: ``,
  imports: [
    DashboardItemComponent,
    TranslatePipe,
    NgIcon,
    PercentPipe,
    InstructionItemComponent,
  ],
  providers: [
    provideIcons({
      lucideBook,
      lucideCheck,
      lucidePointer,
      lucideTrophy,
      lucideInfo,
    }),
  ],
})
export class DashboardComponent {
  instructions = this.store.selectSignal(InstructionSelectors.instructions);

  isLoading = computed(() => this.instructions().isLoading);

  openCourses = computed(() => {
    return this.instructions().openInstructions.filter(
      (i) => i.instruction.type == "Schulung",
    ).length;
  });

  finishedCourses = computed(() => {
    return this.instructions().confirmedInstructions.filter(
      (i) => i.instruction.type == "Schulung",
    ).length;
  });

  openInstructions = computed(() => {
    return this.instructions().openInstructions.filter(
      (i) => i.instruction.type == "Unterweisung",
    ).length;
  });

  finishedInstructions = computed(() => {
    return this.instructions().confirmedInstructions.filter(
      (i) => i.instruction.type == "Unterweisung",
    ).length;
  });

  information = computed(() => {
    return this.instructions().openInstructions.filter(
      (i) => i.instruction.type == "Information",
    ).length;
  });

  progress = computed(() => {
    // we do not include Information
    const total =
      this.finishedCourses() +
      this.finishedInstructions() +
      this.openCourses() +
      this.openInstructions();

    const finished = this.finishedCourses() + this.finishedInstructions();
    return total > 0 ? finished / total : 0;
  });

  constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
  ) {
    this.store.dispatch(
      InstructionActions.loadInstructions({
        instructionType: "All",
      }),
    );
  }

  navigateToCourses() {
    this.router.navigate(["/courses"]);
  }

  navigateToInstructions() {
    this.router.navigate(["/instructions"]);
  }

  navigateToInformation() {
    this.router.navigate(["/information"]);
  }

  navigateTo(
    instruction: Instruction,
    instructionConfirmation: InstructionConfirmation,
  ) {
    let routePart = "courses";
    if (instruction.type == "Unterweisung") {
      routePart = "instructions";
    } else if (instruction.type == "Information") {
      routePart = "information";
    }

    this.router.navigate([
      routePart,
      instruction.name,
      instructionConfirmation.name,
    ]);
  }
}
